import { render, staticRenderFns } from "./ReportCrowded.vue?vue&type=template&id=95d283ec"
import script from "./ReportCrowded.vue?vue&type=script&lang=js"
export * from "./ReportCrowded.vue?vue&type=script&lang=js"
import style0 from "./ReportCrowded.vue?vue&type=style&index=0&id=95d283ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports